import React from 'react';
import './Project.css';

const Project = (props) => {
  return (
    <div className="project-container">
      <div className="project-center">
        <h2>{props.title}</h2>
        <p>{props.skills}</p>
        <p>
          <a target="_blank" href={props.git} rel="noreferrer">
            {props.git ? 'Git' : ''}
          </a>
        </p>
      </div>
    </div>
  );
};

export default Project;
